import type { SVGProps } from 'react'

export const CurrencyYenFilledIcon = ({
  ...props
}: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
      {...props}
    >
      <path d="M450-170v-123.85H280q-12.75 0-21.37-8.63-8.63-8.62-8.63-21.38t8.63-21.37q8.62-8.62 21.37-8.62h170V-450H280q-12.75 0-21.37-8.63-8.63-8.63-8.63-21.38 0-12.76 8.63-21.37Q267.25-510 280-510h141.08L253.62-774q-9.93-15-1.12-30.5 8.81-15.5 26.76-15.5 8.23 0 14.96 3.79 6.73 3.78 10.47 10.6L480-529.15l175.31-276.46q3.74-6.82 10.47-10.6 6.73-3.79 14.96-3.79 17.95 0 26.76 15.62 8.81 15.61-1.12 31L538.92-510H680q12.75 0 21.37 8.63 8.63 8.63 8.63 21.38 0 12.76-8.63 21.37Q692.75-450 680-450H510v96.15h170q12.75 0 21.37 8.63 8.63 8.63 8.63 21.39 0 12.75-8.63 21.37-8.62 8.61-21.37 8.61H510V-170q0 12.75-8.63 21.37-8.63 8.63-21.38 8.63-12.76 0-21.37-8.63Q450-157.25 450-170Z" />
    </svg>
  )
}
